// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem('access_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auto-refresh once on 401, then retry the original request
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    if (response?.status !== 401 || config.__retried) throw error;

    try {
      refreshing = refreshing || axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/refresh`,
        {},
        { withCredentials: true }
      );
      const r = await refreshing;
      refreshing = null;

      const newToken = r.data?.access_token;
      if (newToken) localStorage.setItem('access_token', newToken);

      config.__retried = true;
      config.headers = config.headers || {};
      if (newToken) config.headers.Authorization = `Bearer ${newToken}`;

      return api.request(config);
    } catch (e) {
      refreshing = null;
      localStorage.removeItem('access_token');
      throw error; // let caller show “please login” etc.
    }
  }
);

export default api;
